import styled from '@emotion/styled';

export const RaceSliderHrList = styled('div', { label: 'RaceSliderHrList' })`
    border-radius: 8px;
    flex: 0 0 300px;
    overflow: hidden;
    position: relative;
    width: 300px;
`;
